import React from 'react'
import PropTypes from 'prop-types'

import { get } from 'lodash'

import { ui } from 'parking-react-common'

import { privileges } from '../redux'

import Label from '../components/Label'

const INTENTS = {
    friend   : ui.INTENT.success,
    owner    : ui.INTENT.primary,
    control  : ui.INTENT.warning,
    viewOnly : ui.INTENT.default
}

const PrivilegeLabel = ({ type }) => (
    <Label text={ privileges.displayName(type) } intent={ get(INTENTS, type, ui.INTENT.default) } />
)

PrivilegeLabel.propTypes = {
    type: PropTypes.string
}

export default PrivilegeLabel
